.num-users-textfield {
    width: 50px;
}
